<div #parent [class.active]="active" [hidden]="!active">
  <div [hidden]="!showPin" class="expander">
    <app-panel-pin></app-panel-pin>
    <hr class="clear" />
  </div>
  <div #container class="content"></div>
</div>
